<template>
    <AcademyLayout 
        :custom-banner="courseBannerData"
        :can-edit-banner="false"
        :is-loading-banner="isLoadingCourse"
        :current-course-id="courseId">
        
        <main class="container">
            <div>
                <b-button @click="goBack" variant="outline-primary">← {{$t('academy.back')}}</b-button>
                <!-- <h1 class="course-title" v-if="course">{{ course.name }}</h1> -->
            </div>

            <!-- loading -->
            <div v-if="isLoadingCourse" class="loading-content">
                <div class="skeleton-modules">
                    <div class="skeleton-module" v-for="n in 3" :key="n"></div>
                </div>
            </div>

            <template v-else>
                <ModulesGrid :modules="modules" @module-select="moduleSelected" />

                <LessonDropdown 
                    v-for="(lesson, index) in activeModule.lessons" 
                    :key="index"
                    :moduleNumber="Number(activeModule.number)" 
                    :lessonNumber="index + 1" 
                    :lesson="lesson"
                    :description="activeModule.description"
                    :modality="course.modality"
                    @activity-selected="handleActivitySelection" 
                />
            </template>
        </main>
    </AcademyLayout>
</template>

<script>
import AcademyLayout from '@/layouts/AcademyLayout.vue';
import ModulesGrid from "@/components/academy/ModulesGrid.vue";
import LessonDropdown from "@/components/academy/LessonDropdown.vue";
import academyData from '@/data/academyData';

export default {
    components: {
        AcademyLayout,
        ModulesGrid,
        LessonDropdown,
    },
    data() {
        return {
            courseId: this.$route.params.courseId,
            course: null,
            modules: [],
            activeModule: { lessons: [], number: 1, description: '' },
            courseBannerData: null,
            isLoadingCourse: true
        };
    },

    async mounted() {
        if (!this.courseId) {
            console.error('No se proporcionó courseId');
            this.$router.push({ name: 'academy' });
            return;
        }
        
        await this.loadCourse();
    },

    methods: {
        async loadCourse() {
            try {
                this.isLoadingCourse = true;
                
                console.log('🔄 Iniciando carga del curso...');
                
                const course = await academyData.getCourseById(this.courseId);
                
                if (!course) {
                    console.error('Curso no encontrado');
                    this.$router.push({ name: 'academy' });
                    return;
                }

                this.course = course;
                console.log('✅ Curso cargado:', course);
                
                this.setupCourseBanner();
                
                this.modules = await academyData.getModulesByCourseId(this.courseId);
                
                if (this.modules.length > 0) {
                    this.activeModule = this.modules[0];
                }
                
            } catch (error) {
                console.error("Error al cargar los módulos del curso:", error);
                this.$router.push({ name: 'academy' });
            } finally {
                this.isLoadingCourse = false;
                console.log('Carga completa');
            }
        },

        setupCourseBanner() {
            if (this.course) {
                this.courseBannerData = {
                    courseId: this.course.id,
                    courseName: this.course.name,
                    courseDescription: this.course.description,
                    institution: this.course.institution,
                    modality: this.course.modality,
                    modulesCount: this.course.modules?.length || this.modules?.length || 0,
                    bannerImage: this.course.imageBanner || this.course.image,
                    backgroundColor: this.course.backgroundColor || '#667eea',
                    institutionLogo: this.course.institutionLogo
                };
                
                console.log('Banner del curso configurado:', this.courseBannerData);
            }
        },

        moduleSelected(moduleNumber) {
            const selectedModule = this.modules.find(module => Number(module.number) === moduleNumber);
            if (selectedModule) this.activeModule = selectedModule;
        },

        handleActivitySelection(activity) {
            console.log('Actividad seleccionada:', activity);
        },

        async goBack() {
            try {
                await this.$router.push({ name: 'academy' });
            } catch (error) {
                if (error.name !== 'NavigationDuplicated') {
                    console.error('Error de navegación:', error);
                }
            }
        }
    }
};
</script>

<style scoped>
.course-title {
    margin: 20px 0;
    color: #333;
}

.container {
    max-width: 1200px;
}

.loading-content {
    margin-top: 30px;
}

.skeleton-modules {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 20px;
}

.skeleton-module {
    height: 150px;
    background: linear-gradient(90deg, #f0f0f0 25%, #e6e6e6 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: loading 1.5s infinite;
    border-radius: 8px;
}

@keyframes loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
</style>